<ul class="ac-rules" aria-live="polite">
  <li [class.ok]="state.length"><span class="ac-rules__mark" aria-hidden="true"></span>{{ "acceptPage.ruleLength" | translate }}</li>
  <li [class.ok]="state.numeric"><span class="ac-rules__mark" aria-hidden="true"></span>{{ "acceptPage.ruleNumeric" | translate }}</li>
  <li *ngIf="similarTo" [class.ok]="state.similar"><span class="ac-rules__mark" aria-hidden="true"></span>{{ "acceptPage.ruleSimilar" | translate }}</li>
</ul>
<span class="ac-help">{{ "acceptPage.ruleCommon" | translate }}</span>
